import ReactDOM from 'react-dom';

/** syntactic sugar for using JSX syntax with ReactDOM.createPortal */
const defaultNode = typeof document !== 'undefined' ? document.body : null;

const Portal = ({
  node = defaultNode,
  children,
}) => (node ? ReactDOM.createPortal(children, node) : null);

export default Portal;
